import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import allowNumbersOnly, { handlePaste } from '../../CommonUtils/CommonValidations';
export default function AfiliationFeeDue() {
    const AfiliationFeeDueValidation = Yup.object({
        data: Yup.array().of(Yup.object().shape({
            totFee: Yup.string().required(ERROR_MSG).nullable(),
            feePaid: Yup.string().required(ERROR_MSG).nullable(),

        })),
    })
    const AffflFeeDueFormik = useFormik({
        initialValues: {
            data: [{

                feeAcYear: "",
                totFee: "",
                feePaid: "",
            }]
        },
        validationSchema: AfiliationFeeDueValidation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAffiliatonFee`;
                    CommonAxiosPost(url, values?.data).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetAcademicYear();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })
    const [acyear, setAcyear] = useState([]);
    const [showTotalExpenditure, setTotalExpenditure] = useState(0)
    function GetAcademicYear() {
        let url = config.url.API_URL + `getFeeStatus`;
        CommonAxiosGet(url).then((res) => {

            if (res?.data?.scode === '01') {
                setAcyear(res?.data?.getFeeStatus);
                let totalDue = 0;

                res?.data?.getFeeStatus?.forEach((data, i) => {
                    AffflFeeDueFormik?.setFieldValue(`data[${i}].feeAcYear`, data?.ac_year || '');
                    AffflFeeDueFormik?.setFieldValue(`data[${i}].feePaid`, data?.fee_paid ?? '');
                    AffflFeeDueFormik?.setFieldValue(`data[${i}].totFee`, data?.tot_fee ?? '');
                    AffflFeeDueFormik?.setFieldValue(`data[${i}].due`, data?.due);
                    const courseDue = parseFloat(data?.tot_fee) - parseFloat(data?.fee_paid);
                    totalDue += courseDue;
                })
                setTotalExpenditure(totalDue.toFixed(2));
            }
            else {
                setAcyear([]);
            }
        })
    }


    useEffect(() => {
        GetAcademicYear();
    }, [])
    const [remainingFee, setRemainingFee] = useState([]);

    const calculateTotalDue = () => {
        let totalDue = 0;
        acyear?.forEach((course, index) => {
            const totFee = parseFloat(AffflFeeDueFormik.values?.data[index]?.totFee) || 0;
            const feePaid = parseFloat(AffflFeeDueFormik.values?.data[index]?.feePaid) || 0;
            const due = totFee - feePaid;
            totalDue += due;
        });
        setTotalExpenditure(totalDue.toFixed(2));
    };

    useEffect(() => {
        calculateTotalDue();
    }, [remainingFee]);

    return (
        <>
            <CommonFormHeading heading="Affiliation Fee status" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AffflFeeDueFormik}>
                        <bie.Row className="px-2 pt-3 mb-3">
                            <Form onChange={AffflFeeDueFormik.handleChange} onSubmit={AffflFeeDueFormik.handleSubmit} className='affl-form'>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Academic Year	</th>
                                                <th>Fee to be Paid	</th>
                                                <th>Fee Paid</th>
                                                <th>Due</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {acyear.map((course, index) => (<><tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{course?.ac_year}
                                                    <Field type="hidden" name={`data[${index}].feeAcYear`} value={course?.ac_year} />
                                                </td>
                                                <td>
                                                    <Field type="text" className="form-control" maxLength="10" name={`data[${index}].totFee`}
                                                        placeholder="Fee to be paid" onPaste={(e) => handlePaste(e)}
                                                        onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            AffflFeeDueFormik.setFieldValue(`data[${index}].totFee`, value);
                                                            const currentPayAmount = parseFloat(value);
                                                            const feePaid = parseFloat(AffflFeeDueFormik.values?.data[index]?.feePaid) || '';
                                                            const remaining = currentPayAmount - feePaid;
                                                            if (feePaid > currentPayAmount) {
                                                                Swal.fire({
                                                                    icon: 'info',
                                                                    text: 'Fee Paid cannot be greater than the Fee to be Paid.',
                                                                    confirmButtonText: 'OK',
                                                                    confirmButtonColor: '#d33',
                                                                    backdrop: false
                                                                });
                                                                AffflFeeDueFormik.setFieldValue(`data[${index}].feePaid`, ''); AffflFeeDueFormik.setFieldValue(`data[${index}].totFee`, '');
                                                                setRemainingFee((prevState) => {
                                                                    const updatedRemainingFees = [...prevState];
                                                                    updatedRemainingFees[index] = 0;
                                                                    return updatedRemainingFees;
                                                                });
                                                                return;
                                                            }
                                                            setRemainingFee((prevState1) => {
                                                                const updatedRemainingFees = [...prevState1];
                                                                updatedRemainingFees[index] = remaining;
                                                                return updatedRemainingFees;
                                                            });
                                                        }}

                                                    />

                                                    <ErrorMessage name={`data[${index}].totFee`} component="div" className="text-error" />
                                                </td>

                                                <td>
                                                    <Field type="text" className="form-control" maxLength="10" name={`data[${index}].feePaid`}
                                                        placeholder="Fee Paid" onPaste={(e) => handlePaste(e)}
                                                        onKeyUp={(e) => {
                                                            const feePaid = parseFloat(e.target.value) || 0;
                                                            AffflFeeDueFormik.setFieldValue(`data[${index}].feePaid`, feePaid);
                                                            const currentPayAmount = parseFloat(AffflFeeDueFormik.values?.data[index]?.totFee);
                                                            const remaining = currentPayAmount - feePaid;
                                                            if (feePaid > currentPayAmount) {
                                                                Swal.fire({
                                                                    icon: 'info',
                                                                    text: 'Fee Paid cannot be greater than the Fee to be Paid.',
                                                                    confirmButtonText: 'OK',
                                                                    confirmButtonColor: '#d33',
                                                                    backdrop: false
                                                                });

                                                                AffflFeeDueFormik.setFieldValue(`data[${index}].feePaid`, ''); // Reset feePaid
                                                                AffflFeeDueFormik.setFieldValue(`data[${index}].totFee`, ''); // Reset currentPayAmount
                                                                setRemainingFee((prevStates) => {
                                                                    const updatedRemainingFees = [...prevStates];
                                                                    updatedRemainingFees[index] = 0; // Reset remaining fee for this index
                                                                    return updatedRemainingFees;
                                                                });
                                                                return;
                                                            }

                                                            setRemainingFee((prevStatess) => {
                                                                const updatedRemainingFees = [...prevStatess];
                                                                updatedRemainingFees[index] = remaining;
                                                                return updatedRemainingFees;
                                                            });
                                                        }}
                                                    />
                                                    <ErrorMessage name={`data[${index}].feePaid`} component="div" className="text-error" />
                                                </td>
                                                <td>   <Field type="text" className="form-control" name={`data[${index}].due`} disabled
                                                    value={parseFloat(AffflFeeDueFormik.values?.data[index]?.totFee || 0) - parseFloat(AffflFeeDueFormik.values?.data[index]?.feePaid || 0)}
                                                />  </td>
                                            </tr>

                                            </>))}
                                            <tr> <td colSpan={4}>Affiliation Fee Due ( Total )</td>
                                                <td>{showTotalExpenditure}
                                                </td>
                                            </tr>
                                            <tr> <td colSpan={4}>Total Payment due to University
                                            </td><td>{showTotalExpenditure}</td></tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="button-cend pt-1 mb-4">
                                    <button type='submit' className='btn btn-success btn-sm float-end'>Submit</button>
                                </div><br />
                            </Form>
                        </bie.Row>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>
        </>
    )
}
